import React, { useState, useEffect } from "react";

const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || "";
const backend_url = rawBackendUrl.startsWith("http://") || rawBackendUrl.startsWith("https://") ? rawBackendUrl : `https://${rawBackendUrl}`;
const API_URL = `${backend_url}/api`;

const AddUser = ({ closeAdduser, setUsersData, roles }) => {
  const [nomInput, setNomInput] = useState("");
  const [emailInput, setEmailInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("password123"); // Valeur par défaut
  const [roleId, setRoleId] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const getToken = () => localStorage.getItem("access_token");

  useEffect(() => {
    console.log("Rôles reçus dans AddUser:", roles);
  }, [roles]);

  const handleRoleChange = (e) => {
    setRoleId(e.target.value);
    setError("");
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    if (!nomInput || !emailInput || !roleId) {
      setError("Tous les champs sont requis.");
      setLoading(false);
      return;
    }

    const selectedRole = roles.find(r => r.id === parseInt(roleId));

    const userData = {
      name: nomInput.trim(),
      email: emailInput.trim(),
      role: parseInt(roleId),
      password: passwordInput, // Envoyer le mot de passe
    };

    console.log("Données envoyées:", userData);

    try {
      const token = getToken();
      if (!token) {
        setError("Vous devez être connecté");
        setLoading(false);
        return;
      }

      const response = await fetch(`${API_URL}/users/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(userData),
      });

      const responseData = await response.json();
      console.log("Réponse du serveur:", responseData);

      if (response.ok) {
        setSuccess("Utilisateur ajouté avec succès !");

        const newUser = {
          id: responseData.data?.id || responseData.id,
          name: userData.name,
          email: userData.email,
          role: selectedRole,
          role_name: selectedRole.name,
          is_active: true
        };

        setUsersData(prev => [...prev, newUser]);

        setTimeout(() => {
          closeAdduser(false);
          setNomInput("");
          setEmailInput("");
          setPasswordInput("password123");
          setRoleId("");
        }, 1500);
      } else {
        const errorMessage = responseData.error ||
          responseData.message ||
          responseData.detail ||
          "Erreur lors de la création";
        setError(`Erreur: ${errorMessage}`);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl w-full max-w-md">
        <form onSubmit={handleSubmit} className="space-y-6">
          <h2 className="text-2xl font-semibold text-gray-800 text-center">
            Ajouter un utilisateur
          </h2>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">
              {error}
            </div>
          )}

          {success && (
            <div className="bg-green-50 border border-green-200 text-green-600 px-4 py-3 rounded-lg text-sm">
              {success}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nom complet
              </label>
              <input
                type="text"
                value={nomInput}
                onChange={(e) => setNomInput(e.target.value)}
                placeholder="Ex: Keira"
                disabled={loading}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5E17EB] disabled:bg-gray-100"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                placeholder="Ex: keira@polymeet.com"
                disabled={loading}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5E17EB] disabled:bg-gray-100"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Mot de passe
              </label>
              <input
                type="text"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                placeholder="Mot de passe par défaut"
                disabled={loading}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5E17EB] disabled:bg-gray-100"
              />
              <p className="text-xs text-gray-500 mt-1">
                Mot de passe par défaut: password123
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Rôle
              </label>
              <select
                value={roleId}
                onChange={handleRoleChange}
                disabled={loading || roles.length === 0}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5E17EB] disabled:bg-gray-100"
              >
                <option value="">
                  {roles.length === 0 ? "Chargement des rôles..." : "Choisir un rôle"}
                </option>
                {roles.map((roleItem) => (
                  <option key={roleItem.id} value={roleItem.id}>
                    {roleItem.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={() => closeAdduser(false)}
              disabled={loading}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition duration-200 disabled:opacity-50"
            >
              Annuler
            </button>

            <button
              type="submit"
              disabled={loading || roles.length === 0}
              className="bg-[#5E17EB] text-white px-4 py-2 rounded-lg hover:bg-[#6C3CFF] transition duration-200 disabled:opacity-50 flex items-center gap-2"
            >
              {loading ? (
                <>
                  <span className="animate-spin">⏳</span>
                  Création...
                </>
              ) : (
                "Ajouter"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUser;